const routes = [
  {
    name: 'Home',
    route: '/'
  },
  {
    name: 'Products',
    route: '/resource'
  }
]

export default routes